var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.integration.id,{tag:"components",attrs:{"model":_vm.integration,"active":_vm.isActive}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }